module.exports = __webpack_public_path__ + "static/media/shape.9752dd80.png";